import React from 'react';
import { Link, useNavigate } from 'react-router';
import { useState, useRef, useEffect } from 'react';
import styles from '../../subject.module.css';
import Button from 'components/Button/Button';
import { useAuth } from 'hooks/auth';
import { UserRole } from 'types/auth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV, faEdit } from '@fortawesome/free-solid-svg-icons';
import { subjectApi } from '../../api/subjectApi';
import { Subject } from '../../types/subject';
import Loading from 'components/Loading/Loading';
import SubjectCard from '../SubjectCard/SubjectCard';

const SubjectList: React.FC = () => {
    const navigate = useNavigate();
    const { user } = useAuth()!;
    const isSuperAdmin = user?.role === UserRole.SUPER_ADMIN;
    const isStudent = user?.role === UserRole.STUDENT;

    // Mock progress data - in a real app this would come from an API or hook
    const getSubjectProgress = (subjectId: string) => {
        const mockProgress: Record<string, { attempted: number; avgScore: number }> = {
            'sustainable-tech': { attempted: 1, avgScore: 88 },
            'mathematics': { attempted: 2, avgScore: 94 },
            'physics': { attempted: 1, avgScore: 82 },
            'biology': { attempted: 0, avgScore: 0 },
        };
        return mockProgress[subjectId] || { attempted: 0, avgScore: 0 };
    };

    const [subjects, setSubjects] = useState<Subject[]>([]);
    const [loading, setLoading] = useState(true);
    const [openMenuId, setOpenMenuId] = useState<string | null>(null);
    const menuRef = useRef<HTMLDivElement>(null);

    const fetchSubjects = async () => {
        setLoading(true);
        try {
            const response = await subjectApi.getAll();
            setSubjects(response.data);
        } catch (error) {
            console.error('Error fetching subjects:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSubjects();
    }, []);



    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setOpenMenuId(null);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className={styles.container}>
            <div className={styles.pageHeader}>
                <div className={styles.titleSection}>
                    <h1 className={styles.title} style={{ marginBottom: 0 }}>Explore Subjects</h1>
                </div>
                {isSuperAdmin && (
                    <Button variant="primary" onClick={() => navigate('/subject/add')}>
                        + Add New Subject
                    </Button>
                )}
            </div>
            {loading ? (
                <Loading message="Loading subjects..." />
            ) : subjects.length > 0 ? (
                <div className={styles.grid}>
                    {subjects.map((subject) => (
                        <SubjectCard
                            key={subject.id}
                            subject={subject}
                            isStudent={isStudent}
                            isSuperAdmin={isSuperAdmin}
                            progress={getSubjectProgress(subject.id)}
                            totalModules={(subject as any).modules?.length || 0}
                            openMenuId={openMenuId}
                            setOpenMenuId={setOpenMenuId}
                            menuRef={menuRef}
                        />
                    ))}
                </div>
            ) : (
                <div className={styles.emptyState}>No subjects found.</div>
            )}
        </div>
    );
};

export default SubjectList;
